import { render, staticRenderFns } from "./ot-multi-select-autocomplete-wrapper.vue?vue&type=template&id=68c952f1&scoped=true&"
import script from "./ot-multi-select-autocomplete-wrapper.vue?vue&type=script&lang=ts&"
export * from "./ot-multi-select-autocomplete-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./ot-multi-select-autocomplete-wrapper.vue?vue&type=style&index=0&id=68c952f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c952f1",
  null
  
)

export default component.exports